import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-computer-line',
    title: 'Formatação de Micros e Notebooks',
    description: 'Formatação completa com instalação do sistema operacional, drivers e programas essenciais. Seu computador como novo!',
    image: 'https://readdy.ai/api/search-image?query=technician%20formatting%20laptop%20computer%20in%20clean%20workshop%2C%20professional%20IT%20repair%20environment%2C%20white%20background%2C%20tools%20and%20equipment%20visible%2C%20teal%20and%20navy%20color%20accents%2C%20modern%20tech%20workspace%2C%20high%20quality%20photography&width=600&height=400&seq=svc001&orientation=landscape',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Montagem de Computadores Gamers',
    description: 'Montagem personalizada de PCs gamers e workstations com os melhores componentes do mercado, dentro do seu orçamento.',
    image: 'https://readdy.ai/api/search-image?query=custom%20gaming%20PC%20build%20with%20RGB%20lighting%20inside%20glass%20case%2C%20colorful%20components%20motherboard%20GPU%20RAM%2C%20dark%20background%20with%20teal%20and%20blue%20glow%2C%20professional%20photography%2C%20high%20end%20gaming%20setup&width=600&height=400&seq=svc002&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    title: 'Limpeza e Manutenção',
    description: 'Limpeza interna completa de notebooks e computadores, troca de pasta térmica e manutenção preventiva para maior durabilidade.',
    image: 'https://readdy.ai/api/search-image?query=technician%20cleaning%20laptop%20motherboard%20with%20compressed%20air%20and%20brush%2C%20professional%20computer%20maintenance%2C%20clean%20white%20workshop%20background%2C%20precision%20tools%2C%20technical%20repair%20environment&width=600&height=400&seq=svc003&orientation=landscape',
  },
  {
    icon: 'ri-remote-control-line',
    title: 'Suporte Remoto',
    description: 'Resolva problemas sem sair de casa! Acesso remoto seguro para diagnóstico e solução de problemas de software rapidamente.',
    image: 'https://readdy.ai/api/search-image?query=remote%20IT%20support%20technician%20working%20on%20dual%20monitors%20with%20remote%20desktop%20connection%2C%20professional%20home%20office%20setup%2C%20teal%20and%20navy%20color%20scheme%2C%20modern%20workspace%2C%20technology%20concept&width=600&height=400&seq=svc004&orientation=landscape',
  },
  {
    icon: 'ri-install-line',
    title: 'Instalação de Softwares',
    description: 'Instalação e configuração de sistemas operacionais, pacotes Office, antivírus, drivers e qualquer software que você precisar.',
    image: 'https://readdy.ai/api/search-image?query=software%20installation%20on%20computer%20screen%20showing%20progress%20bar%2C%20professional%20IT%20setup%2C%20clean%20desk%20environment%2C%20teal%20and%20blue%20interface%2C%20modern%20technology%20workspace%2C%20high%20quality%20photo&width=600&height=400&seq=svc005&orientation=landscape',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Criação de Sites',
    description: 'Sites modernos, responsivos e otimizados para o Google. Criamos a presença digital ideal para sua empresa crescer online e atrair mais clientes.',
    image: 'https://readdy.ai/api/search-image?query=web%20designer%20creating%20a%20modern%20colorful%20website%20on%20large%20monitor%20in%20bright%20creative%20studio%2C%20vibrant%20UI%20mockups%20on%20screen%2C%20teal%20and%20coral%20color%20palette%2C%20design%20tools%20visible%2C%20professional%20digital%20agency%20workspace%2C%20high%20quality%20photography&width=600&height=400&seq=svc006b&orientation=landscape',
  },
];

export default function ServicesPreview() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 text-[#00c9a7] text-xs font-semibold uppercase tracking-widest mb-4">
            <span className="w-8 h-px bg-[#00c9a7]" />
            O que fazemos
            <span className="w-8 h-px bg-[#00c9a7]" />
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-[#0d1b2a] mb-4">
            Nossos Serviços Especializados
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            Soluções completas em informática para residências e empresas. Atendemos no local ou de forma remota.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group relative rounded-2xl overflow-hidden bg-[#f8fafb] border border-gray-100 hover:border-[#00c9a7]/30 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-4 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#00c9a7]/10 mb-3 md:mb-4">
                  <i className={`${service.icon} text-[#00c9a7] text-xl`} />
                </div>
                <h3 className="text-[#0d1b2a] font-bold text-sm md:text-base mb-2">{service.title}</h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/servicos"
            className="inline-flex items-center gap-2 bg-[#1a3a4a] hover:bg-[#0d1b2a] text-white font-semibold px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            Ver Todos os Serviços
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
